import { z } from "zod";

const zDirection = z.enum(["ASC", "DESC"]);
const Direction = zDirection.Enum;
type Direction = z.infer<typeof zDirection>;

function zSchema<FieldNames extends z.ZodEnum<[string, ...string[]]>>(fieldNames: FieldNames) {
  return z
    .object(
      Object.fromEntries(
        Object.values(fieldNames.Enum).map((value) => [value, zDirection]),
      ) as Record<z.infer<FieldNames>, typeof zDirection>,
    )
    .partial();
}
type Schema<FieldNames extends z.ZodEnum<[string, ...string[]]>> = z.infer<
  ReturnType<typeof zSchema<FieldNames>>
>;

export { Direction, zDirection, zSchema };
export type { Schema };
